import api from '../callApi';
import humanparser from 'humanparser';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const completePetition = (apiRequestData, actionCompletedTime, values) => {
    const name = humanparser.parseName(values.fullName);
    let address = {
        streetNo: parseAddressNumber(values.address),
        street: parseAddressStreet(values.address),
        state: values.stateId,
        city: values.homeCity,
        country: values.country,
        zipCode: values.postalCode,
        source: 0 // is user input
    };

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,

        email: values.email,
        from: values.petition,
        firstName: name.middleName
            ? name.firstName + ' ' + name.middleName
            : name.firstName,
        lastName: name.lastName,
        prefix: values.prefix,
        text: values.message,
        notifyResult: values.getUpdates,
        partnerOptIn: values.partnerOptIn,
        phoneNumber: values.phone,
        address: address
    };

    return api.post('Widget/CompletePetitionAsync', request).then(response => {
        return response;
    });
};

export default completePetition;
